import React, { Component } from "react"
import PropTypes from "prop-types"
import findIndex from "lodash/findIndex"
import { withRadium } from "higher-order-components"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actionCreators, selectors } from "store/actions/mymazda"
import { Link } from "react-router-dom"
import COLOR_PALETTE from "constants/color-palette"
import { BASE_HEADING } from "constants/general-style"
import { TickModalIcon } from "components"
import gtmHandler from "AtomicUtils/gtmHandler"
import { P, Space, Interactive } from "AtomicComponents"
import classnames from "classnames"
import buttonStyles from "AtomicComponents/Button/Button.less"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

class VehicleServiceCarouselItem extends Component {
  constructor(props) {
    super(props)

    this.setService = code => {
      this.props.updateServiceDetails(
        {
          activeServiceCodeIndex: this.activeServiceCodeIndex(code),
          selectedAdditionalServices: {}
        },
        this.props.vin
      )
    }

    this.activeServiceCodeIndex = factoryCode => {
      if (this.props.serviceOptions) {
        return findIndex(this.props.serviceOptions.serviceItems, { factoryCode })
      }
      return 0
    }

    this.state = {
      mounted: false
    }
  }

  componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  render() {
    const {
      item,
      index,
      currentIndex,
      serviceDetailpageUrl,
      requestServicePageUrl,
      requestComplementaryServicePageUrl,
      complementaryServiceImage,
      scheduledServiceImage,
      gtmEvent,
      primaryButtonText = "Request service",
      secondaryButtonText = "WHAT'S INCLUDED?",
      gtmOnCarouselButtonClick
    } = this.props

    return (
      <div
        key={item.factoryCode}
        style={[styles.tile, this.state.mounted ? styles.in(index * 0.1) : styles.out]}>
        <div style={styles.base(currentIndex === index)}>
          <div style={styles.coverImg}>
            {item.isComplementaryService ? (
              <div style={styles.complementaryServiceImage}>
                <figure style={styles.figure(complementaryServiceImage)}>
                  <img
                    src={complementaryServiceImage}
                    alt={item.serviceDescription}
                    style={{ width: "100%", height: "100%", opacity: 0 }} />
                </figure>
                <span style={styles.heading(item.isComplementaryService)}>{item.serviceDescription}</span>
              </div>
            ) : (
              <div style={styles.scheduledServiceImage}>
                {scheduledServiceImage && (
                  <img src={scheduledServiceImage} alt={item.serviceDescription} />
                )}
                <span style={styles.heading(item.isComplementaryService)}>{item.serviceDescription}</span>
              </div>
            )}
            {item.isCompleted && (
              <TickModalIcon
                style={{
                  width: "2.25em",
                  height: "2.25em",
                  position: "relative",
                  transform: "translateY(-50%)"
                }} />
            )}
          </div>
          <div style={styles.details}>
            <P withoutMargin>ESTIMATED PRICE</P>
            <Space />
            <P
              withoutMargin
              data-test={"price"}
            >
              {item.customerTotal || item.price}
            </P>
            <Space />
            <div
              onClick={() => {
                this.setService(item.factoryCode)
              }}>
              <Link
                to={
                  item.isComplementaryService
                    ? requestComplementaryServicePageUrl
                    : requestServicePageUrl
                }
                className={`Button ${classnames({
                  [buttonStyles.Button]: true,
                  [buttonStyles.ButtonFullWidth]: true,
                  [buttonStyles.ButtonRed]: true
                })}`}>
                <span
                  onClick={() => {
                    gtmHandler({
                      pageCategory: "MyMazda - Servicing",
                      pageAction: `Carousel - clicked "${item.isComplementaryService ? "REQUEST INSPECTION" : primaryButtonText.toUpperCase()}"`
                    })
                  }}>
                  {item.isComplementaryService ? "Request inspection" : primaryButtonText}
                </span>
              </Link>
              <div style={styles.hr} />
              <Link
                to={
                  item.isComplementaryService
                    ? requestComplementaryServicePageUrl
                    : serviceDetailpageUrl
                }
                className={classnames({
                  [typographyStyles.withoutStyle]: true
                })}
                key="survey">
                <Interactive>
                  <span
                    onClick={() =>
                      gtmHandler({
                        pageCategory: "MyMazda - Servicing",
                        pageAction: `Carousel - clicked "${secondaryButtonText.toUpperCase()}"`
                      })
                    }>
                    {secondaryButtonText}
                  </span>
                </Interactive>
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

VehicleServiceCarouselItem.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  currentIndex: PropTypes.number,
  serviceDetailpageUrl: PropTypes.string,
  requestServicePageUrl: PropTypes.string,
  requestComplementaryServicePageUrl: PropTypes.string,
  complementaryServiceImage: PropTypes.string,
  scheduledServiceImage: PropTypes.string,
  serviceOptions: PropTypes.object,
  updateServiceDetails: PropTypes.func,
  vin: PropTypes.string,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  gtmEvent: PropTypes.func,
  gtmOnCarouselButtonClick: PropTypes.func
}

const styles = {
  base: opacity => ({
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: `1px solid ${COLOR_PALETTE.GRAY}`,
    minHeight: "200px",
    width: "100%",
    flexDirection: "column",
    height: "100%",
    textDecoration: "none",
    color: "#101010",
    transition: "opacity 0.5s",
    opacity: opacity ? "1" : "0.3"
  }),
  coverImg: {
    left: "0px",
    top: "0px",
    bottom: "0px",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    height: "200px",
    backgroundColor: COLOR_PALETTE.GRAY_LIGHT
  },
  figure: bg => ({
    backgroundImage: `url(${bg})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0
  }),
  heading: isComplementaryService => ({
    ...BASE_HEADING,
    color: isComplementaryService ? "#fff" : "#101010",
    fontSize: "16px",
    left: isComplementaryService ? "50%" : "auto",
    padding: isComplementaryService ? "" : "20px 5% 0",
    position: isComplementaryService ? "absolute" : "relative",
    textAlign: "center",
    top: isComplementaryService ? "50%" : "auto",
    transform: isComplementaryService ? "translateX(-50%) translateY(-50%)" : "none",
    width: "90%"
  }),
  details: {
    padding: "1.5em 1.5em 1.25em",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginLeft: "0px",
    width: "100%"
  },
  readMore: {
    fontSize: "81%",
    color: "#aaaaaa",
    transition: ".5s",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    fontWeight: "600",
    letterSpacing: ".2em",
    textTransform: "uppercase",
    width: "100%",
    ":hover": { color: "black" }
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1.25em",
    paddingBottom: "1.5em"
  },
  scheduledServiceImage: {
    padding: "1em",
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  complementaryServiceImage: {
    height: "100%",
    position: "relative",
    width: "100%"
  },
  tile: {
    display: "flex",
    maxWidth: "280px",
    width: "280px",
    flex: "1 0 auto"
  },
  in: delay => ({
    transitionDuration: "1s",
    transitionDelay: `${delay}s`,
    willChange: "transform"
  }),
  out: {
    opacity: 0,
    transform: "translateY(-3em)",
    willChange: "transform"
  }
}

const mapStateToProps = (state, props) => ({
  service: selectors.getService(props.vin)(state)
})

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch)

export default withRadium(connect(mapStateToProps, mapDispatchToProps))(VehicleServiceCarouselItem)



// WEBPACK FOOTER //
// ./src/components/mymazda/service/carousel-item.jsx